import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Router from 'next/router';
import { Button } from "../index";

import { RecipePanel, RecipeItem, RecipeDelimiter, RecipeButtonContainer } from "./styles";

const PassRecipe = ({ bookedDate, code, highlight, name, price, totalPrice, payment, guestName }) => (
  <RecipePanel>
    <RecipeItem>
      <span className="title">
        {name}
        <span className="subtitle">{highlight}</span>
      </span>
      <span className="price small blue">${price / 100}</span>
    </RecipeItem>
    <RecipeDelimiter />
    <RecipeItem>
      <span className="field">Guest Name</span>
      <span className="value">{guestName}</span>
    </RecipeItem>
    <RecipeItem>
      <span className="field">Membership ID</span>
      <span className="value">{code}</span>
    </RecipeItem>
    <RecipeItem>
      <span className="field">Valid through</span>
      <span className="value">{moment(bookedDate).format('MMM DD, YYYY')}</span>
    </RecipeItem>
    <RecipeDelimiter />
    <RecipeItem>
      <span className="field normal">Subtotal</span>
      <span className="price normal small">${price / 100}</span>
    </RecipeItem>
    <RecipeItem>
      <span className="field bold">Total</span>
      <span className="price large bold">${totalPrice / 100}</span>
    </RecipeItem>
    <RecipeDelimiter />
    <RecipeItem>
      {payment.paidBy.name !== undefined ? (
        <Fragment>
          <span className="field normal">{payment.paidBy.name}</span>
          <span className="value">•••• {payment.paidBy.value}</span>
        </Fragment>
      ) : (
        <Fragment>
          <div>Paid by</div>
          <div>PayPal</div>
        </Fragment>
      )}
    </RecipeItem>
    <RecipeItem>
      <span className="field normal">Purchased</span>
      <span className="value">{moment(bookedDate).format('MMM DD, YYYY')}</span>
    </RecipeItem>
    <RecipeButtonContainer>
      <Button htmlType="button" theme="primary" onClick={() => Router.push('/s/day-passes')}>Reserve Your Pass</Button>
    </RecipeButtonContainer>
  </RecipePanel>
);

PassRecipe.propTypes = {
  bookedDate: PropTypes.string,
  code: PropTypes.string,
  highlight: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  totalPrice: PropTypes.number,
  payment: PropTypes.instanceOf(Object),
  guestName: PropTypes.string,
};

export default PassRecipe;
